const fixedSubmitEl = document.querySelector('.product-form__submit_fixed');
const waypoint = new Waypoint({
  element: document.querySelector('.product-form__buttons > .product-form__submit'),
  handler: function(direction) {
    if(direction === 'down') {
      fixedSubmitEl.classList.add('unfixed');
    } else {
      fixedSubmitEl.classList.remove('unfixed');
    }
  },
  offset: '100%'
});

document.addEventListener('DOMContentLoaded', () => {
  const productDescriptionLength = parseInt(document.querySelector('.product__description').dataset.length);
  const productDescription = new Cuttr('.product__description[data-truncate="true"]', {
    truncate: 'words',
    length: productDescriptionLength,
    readMore: true,
    readMoreText: window.productStrings.readMore,
    readLessText: window.productStrings.readLess,
    readMoreBtnPosition: 'inside',
  });
});
